import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "src/components/input";
import Actions from "src/components/actionbar";
import type { AppDispatch } from "src/redux/store";
import { ReportState } from "../..";
import InfiniteScroll from "src/components/infiniteScroll";
import { searchSkills } from "src/redux/actions/coaching/settings";

import _ from "lodash";
import styles from "./skills.module.scss";
import Text from "src/components/text";
import { Skill } from "src/types/coaching/courses";
interface SkillsProps {
  reportState: ReportState;
  onReportStateChange: (state: ReportState) => void;
}

const Skills: React.FC<SkillsProps> = ({
  reportState,
  onReportStateChange,
}) => {
  const { loading, skills, nextPage, hasMoreItems } = useSelector(
    (state: any) => {
      const skillsState = _.get(state, "coaching.settings.skills");
      const loading = _.get(skillsState, "loading");
      const pagination = _.get(skillsState, "pagination");
      const total = _.get(pagination, "totalPages", 0);
      const hasMoreItems = _.get(pagination, "hasMoreItems");
      const currentPage = _.get(pagination, "currentPage", 0);

      const skills = _.get(skillsState, "searchResults") || [];

      let nextPage: number | null = _.get(pagination, "currentPage", 0) + 1;
      if (nextPage && nextPage >= total) {
        nextPage = null;
      }

      return {
        loading: loading,
        skills: skills,
        currentPage: currentPage,
        nextPage: nextPage,
        hasMoreItems: hasMoreItems,
      };
    },
    _.isEqual,
  );

  const dispatch = useDispatch();

  const [query, setQuery] = useState<string | null>("");

  const toggleSkill = (skill: Skill) => {
    let items = [...reportState.skills];

    const selected = _.find(items, (item) => item.id === skill.id);

    if (selected) {
      items = items.filter((item) => item.id !== skill.id);
    } else {
      items = [...items, skill];
    }

    onReportStateChange({
      ...reportState,
      skills: items,
    });
  };

  const handleQueryChange = (query: string | null) => {
    setQuery(query);
  };

  const searchSkillsForPage = (query, page) => {
    const request = {
      query: query,
      parent: null,
      page: page,
      limit: 20,
    };

    dispatch(searchSkills(request));
  };

  const handleLoadMore = () => {
    if (nextPage) {
      searchSkillsForPage(query, nextPage);
    }
  };

  useEffect(() => {
    searchSkillsForPage(query, 0);
  }, []);

  useEffect(() => {
    searchSkillsForPage(query, 0);
  }, [query]);

  return (
    <div className={styles.container}>
      <div className={styles.inputContainer}>
        <Actions.Search query={query} onSearch={handleQueryChange} />
      </div>
      <InfiniteScroll
        className={styles.skillsList}
        loading={loading}
        hasMore={hasMoreItems}
        loadMore={handleLoadMore}
        loader={() => {
          return <div>loading skills..</div>;
        }}
      >
        {_.size(skills) === 0 && !loading && (
          <span className={styles.noRecordsFound}>No results found.</span>
        )}

        {_.size(skills) > 0 && (
          <div className={styles.skills}>
            {skills.map((skill) => {
              const selected = _.find(reportState.skills, (item) => item.id === skill.id);
              return (
                <div className={styles.skill} key={skill.id}>
                  <Text className={styles.name} text={skill.name} lines={1} />
                  <Checkbox
                    checked={!!selected}
                    onChange={() => toggleSkill(skill)}
                  />
                </div>
              );
            })}
          </div>
        )}
      </InfiniteScroll>
    </div>
  );
};

export default Skills;
